import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { AlertComponent } from '../../alert/alert.component';
import { InvestorService } from 'src/app/services/investor.service';
import { environment } from 'src/environments/environment';
declare var $: any;
import * as _ from 'lodash';
@Component({
  selector: 'app-masterinvestorcomplaints',
  templateUrl: './masterinvestorcomplaints.component.html',
  styleUrls: ['./masterinvestorcomplaints.component.css']
})
export class MasterinvestorcomplaintsComponent implements OnInit {

  public environmentSettings: any;
  isSearchDivVisible = false;
  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;
  dtOptionsOfMasterDirector: DataTables.Settings = {};
  dtOptionsOfRegisterDirector: DataTables.Settings = {};
  registerDirectorList: any[];
  masterDirectorList: any[];
  dateOfReceiptOfComplaint: any[];
  dtTriggerMasterDirector: Subject<any> = new Subject();
  dtTriggerRegisterDirector: Subject<any> = new Subject();
  error: any = { isError: false, errorMessage: '' };
  currentURL: any;
  response: boolean;
  deleteInvestorComplaintsDetails: any;
  dateOfReceiptOfComplaintModel: any;
  dateOfComplaint: any;
  nameOfPersonLodgingComplaint: any;
  TodayDate: NgbDateStruct;
  editParticularId: any;
  futureToDate: NgbDateStruct;
  futureToDateTo: NgbDateStruct;
  

  constructor(private investorService: InvestorService, private activatedRoute: ActivatedRoute, private router: Router,
    private commonFunction: CommonFunction, private alert: AlertComponent) {

    this.response = false;
  }

  ngOnInit() {
    this.environmentSettings = environment;
    this.dtOptionsOfRegisterDirector = {
      destroy: true,
      scrollY: "200px",
      scrollCollapse: true,
      scrollX: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [8] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Investor Complaints',
          title: 'Investor Complaints',
          extend: 'excel',
          exportOptions: {
            columns: [0, 2, 4, 5, 6,7],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
          }

        }
      ]
    };

    this.getRegisterDirectorList();

    this.currentURL = window.location.href;

    var haseditpermisssion: any = false;
    if (this.currentURL.includes('edit') && !environment.PSS) {
      haseditpermisssion = this.commonFunction.validateURL('Director', 'edit');
    }
    else if (environment.PSS) {
      haseditpermisssion = this.commonFunction.validateURL('Director', 'add');
    }
    haseditpermisssion = false;

    var dateObj = new Date();
    var month = dateObj.getUTCMonth() + 1; //months from 1-12
    var day = dateObj.getUTCDate();
    var year = dateObj.getUTCFullYear();
    this.TodayDate = { year: year, month: month, day: day };
  }
  add(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['investor','add']  } }],
      { relativeTo: this.activatedRoute.parent });
  }
  toggleSearchDiv() {
    this.isSearchDivVisible = !this.isSearchDivVisible;
  }
  adjustdirectormasterTable() {
    var directorData = this.masterDirectorList;
    if (directorData.length) {
      this.masterDirectorList = [];
      $("#directormasterinvestorTable").DataTable().destroy();
      this.masterDirectorList = directorData;
      this.dtTriggerMasterDirector.next();
      setTimeout(() => {
        $("#directormasterinvestorTable").DataTable().columns.adjust().draw();
      }, 200);
    }
  }

  tabRegisterOfDirectorOnClickEvent() {
    setTimeout(() => {
      $("#directormasterinvestorTable").DataTable().columns.adjust().draw();
    });
  }

  getRegisterDirectorList() {

    this.registerDirectorList = [];
    this.investorService.getRegisterDirector({ isSearch: false }).subscribe(registerList => {
      this.registerDirectorList = registerList.data;
      this.dtTriggerRegisterDirector.next();
    });
  }
  generateOutput() {
    let companyId = JSON.parse(localStorage.getItem('companyDetails')).companyID;
    var object = {
      id: null,
      fromDate: this.dateOfComplaint,
      toDate: this.dateOfReceiptOfComplaintModel,
      name: this.nameOfPersonLodgingComplaint
    }
    this.investorService.generateInvestorDocument(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(companyId);
          setTimeout(function () {
            self.downloadPdfDocument(companyId);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.investorService.downloadInvestorFile(id, 'Multi');
  }
  downloadPdfDocument(id) {
    this.investorService.downloadInvestorPdfFile(id, 'Multi');
  }

  confirmDelete(id) {
    this.deleteInvestorComplaintsDetails = id;
    $("#deleteConfirm").modal('toggle');
  }

  removeinvestordetail() {

    this.investorService.removeinvestordetails(this.deleteInvestorComplaintsDetails)
      .subscribe(response => {
        if (response.status == 0) {
          this.alert.success(response.message);
          $("#directormasterinvestorTable").DataTable().destroy();
          $("#deleteConfirm").modal('toggle');
        } else {
          this.alert.success(response.message);
        }
        this.getRegisterDirectorList();

      });

  }

  editinvestor(directorId) {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['investor','edit',directorId]  } }],
      { relativeTo: this.activatedRoute.parent });
    // this.router.navigate(['/investor/edit/', directorId]);
  }

  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }

  doAdvSearch() {
    this.response = true;
    var searchParam =
    {
      "nameOfPersonLodgingComplaint": this.nameOfPersonLodgingComplaint,
      'dateOfComplaint': this.setDate(this.dateOfComplaint),
      'dateOfReceiptOfComplaintModel': this.setDate(this.dateOfReceiptOfComplaintModel),
      'isSearch': true,
    };
    this.registerDirectorList = [];
    $("#directormasterinvestorTable").DataTable().destroy();
    this.investorService.getRegisterDirector(searchParam).subscribe(registerList => {
      this.response = false;
      this.registerDirectorList = registerList.data;
      this.dtTriggerRegisterDirector.next();
    });
  }
  clearAdvSearch() {
    this.nameOfPersonLodgingComplaint = '';
    this.dateOfComplaint = undefined;
    this.dateOfReceiptOfComplaintModel = undefined;
    $("#directormasterinvestorTable").DataTable().destroy();
    this.getRegisterDirectorList();
  }
}
